import React, { useEffect, useContext } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { motion, useAnimation } from "framer-motion"

import Context from "context/"
import ContentWrapper from "styles/contentWrapper"
import { lightTheme, darkTheme } from "styles/theme"
import Card from "components/common/card"
import fileImg from "content/images/file.svg"
import docImg from "content/images/search.svg"
import peopleImg from "content/images/people.svg"
import spins from "content/images/spins.svg"


const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.solitudeLight};
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: center;
    padding-top: 5.68rem;
    .title {
      color: ${({ theme }) => theme.colors.zodiacDark};
      font-weight: 400;
      font-size: 2rem;
      line-height: 2.375rem;
      margin: 0;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
          font-size: 3.125rem;
          line-height: 3.875rem;
      }
    }
    .subtitle {
      color: ${({ theme }) => theme.colors.tertiary};
      font-weight: 400;
      font-size: 1.05rem;
      line-height: 1.8rem;
      max-width: 45rem;
      margin: auto;
    }
    padding-bottom: 14rem;
  }
`
const StyledCardsWrapper = styled.div`
  min-height: 19rem;
  display: flex;
  margin: auto;
  margin-top: 2rem;
`


const Demos = ({ content, children }) => {
  const { frontmatter } = content[0].node
  const { isIntroDone, darkMode } = useContext(Context).state

  // Controls to orchestrate animations of greetings, emoji, social profiles, underlining
 
  return (
    <StyledSection>
      <StyledContentWrapper>
        <div>
          <div className="section-label">{frontmatter.label}</div>
          <h2 className="title mb-05">
            {frontmatter.titlePrefix} <br />{frontmatter.title}
          </h2>
          <h2 className="subtitle">
            {frontmatter.description}
          </h2>
        </div>
        {children}
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default Demos
